<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I dedicate this book to my friends, Wayne Catchpole, Fran Wood, Chris Roberts, Christine Coombes, Matthew Hamilton and Olivia Willoughby. Thanks also to Gary White, who made <em>Eternal Fire</em> possible—and to the mystery man who inspired the character Josh in the book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0464ce8c